import React, { Component } from 'react';
import {API} from "../_redux/helper"
import {priceSplitter, checkId, required} from "../_redux/function"
import axios from "axios"
import Radio from '@material-ui/core/Radio';
import { connect } from "react-redux";
import { getJobType} from "../_actions/jobs"
import { getProvince, getCity, getCountry} from "../_actions/user";
import {getListEducation} from "../_actions/education";
import {DatePicker,MuiPickersUtilsProvider,} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import closemodal from "../images/closemodal.png";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import default_company from "../images/default_company.svg"
import {getIndustri, getJobFunction,getJobLevel} from "../_actions/work";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import warning_referral from "../images/warning_referral.svg"
import Modal from "react-awesome-modal"
import Policy from "./Policy";
import Terms from "./Terms";
import {GAevent} from './TrackingEvent'
import { Helmet } from 'react-helmet';
import { Upload, message } from "antd";
import CryptoJS from 'crypto-js';
var key = CryptoJS.enc.Utf8.parse("68D83A2CCC84F2A8B7ADB64B38B86576")
var iv = CryptoJS.enc.Utf8.parse("116C893F5CF1AA0AFAABBF28C32CFBE2")       
var $ = require("jquery");


class Job_Apply extends Component {
    constructor(){
        super();
        this.componentRef = React.createRef();
        this.state={
            selectedValue:"B",
            check:1,
            data_job:{},
            cv:"",
            kt:"",
            terms:false,
            policy:false,
            job_function_id:[],
            industry_id:[],
            new_pass:true,
            confirm_pass:true,
            work_period_start: "",
            work_period_end: "",
            link:"",
            failed:false,
            work_exp:[
                {job_title:"",company_name:"",work_period_start:new Date(),work_period_end:new Date(),
                still_work:"", job_level:"", job_function:"",industry:"", key_responsibility:""},{
                    job_title:"",
                    company_name:"",
                    work_period_start:new Date(),
                    work_period_end:new Date(),
                    still_work:"",
                    job_level:"",
                    job_function:"",
                    industry:"",
                    key_responsibility:"",
                },{
                    job_title:"",
                    company_name:"",
                    work_period_start:new Date(),
                    work_period_end:new Date(),
                    still_work:"",
                    job_level:"",
                    job_function:"",
                    industry:"",
                    key_responsibility:"",
                }
            ],
            fill_out:"",
            expanded_work:[true,true,true],
            still_study:false,
            still_work:[false,false,false]
        }
    }

    componentDidMount(){
        this.props.getCountry();
        this.props.getIndustri();
        this.props.getJobFunction();
        this.props.getJobLevel();
        this.props.getJobType();
        this.props.getListEducation()

    }

    handleChange=(e)=>{
        this.setState({selectedValue:e})
    }

    changeCountry=(e)=>{
        this.props.getAllCity(e) 
    }

    handleCallback = (childData) =>{
        this.setState({link: childData})
    }

    expandedWork=(e,y)=>{
        let {expanded_work} = this.state
        expanded_work[y] = e
        this.setState({expanded_work})
    }

    changeJob=(e)=>{
        const cek1 =  [...this.state.job_function_id]
        const index = cek1.indexOf(e);
        if (this.state.job_function_id.length <5){
        if (index===-1){
            cek1.push(e)
        }else{
            cek1.splice(index,1)
        }
        this.setState({job_function_id: cek1})
        }
}

addWork=(e,y)=>{
    if (e <3){
    const {work_exp}= this.state
    const data = {
        job_title:"",
        company_name:"",
        work_period_start:new Date(),
        work_period_end:new Date(),
        still_work:"",
        job_level:"",
        job_function:"",
        industry:"",
        key_responsibility:"",
    }
    work_exp.push(data)
    this.setState({work_exp:work_exp})
}
}

changeWork=(e,y,i)=>{
let {work_exp, still_work} = this.state
work_exp[i][y] = e
if (y==="still_work"){
if (e===true){
    work_exp[i][y] = 1
    work_exp[i]["work_period_end"]=new Date()
}else{
    work_exp[i][y] = 0
}
still_work[i]=!still_work[i]
this.setState({still_work})
}
this.setState({work_exp})

}

changeIndustry=(e)=>{
    const cek1 =  [...this.state.industry_id]
    const index = cek1.indexOf(e);
    if (this.state.industry_id.length <5){
    if (index===-1){
        cek1.push(e)
    }else{
        cek1.splice(index,1)
    }
    this.setState({industry_id: cek1})
    }
}

    setData=(e,y)=>{
        const {data_job, still_study} = this.state
        data_job[y] = e
        if (y==="latest_salary" || y==="expected_salary" || y==="phone_number"){
            let k = e.match(/\d/g)
            if (k !== null){
                k=k.join("")
            }
            data_job[y] = k
            this.setState({data_job})
        }else if (y==="full_name"){
            const reg = /^(?![\s.]+$)[a-zA-Z\s.]*$/
            if (reg.test(e)==true){
            this.setState({data_job})
            }
        }else if (y==="still_study" ){
            this.setState({still_study:!still_study})
            if(still_study===false){
                data_job["still_study"]=1
                data_job["education_period_end"]= new Date()
            }else{ 
                data_job["still_study"]=0
            }
            this.setState({data_job})
            
        }else{

        if (y==="country_id"){
            this.props.getProvince(e)
        }else if (y==="state_id"){
            this.props.getCity(e)
        }
        this.setState({data_job})
    }
    if (y==="know_KT" && e===""){
        this.setState({fill_out:"Please fill out this field"})
    }else{
        this.setState({fill_out:""})
    }

    }


    closeAll=(e)=>{
        const n = this.state.data_job
        let {work_exp}= this.state
        n["full_name"]=n["email"]=n["birth_date"]=n["gender"]=n["full_name"]=n["password"]=n["area"]=n["country_id"]
        =n["state_id"]=n["city_id"]=n["latest_salary"]=n["expected_salary"]=n["educational_stage"]=n["institution_name"]
        =n["degree"]=n["still_work"]=n["still_study"]=n["job_id"]=n["currently_working"]=n["confirm_password"]
        =n["key_responsibility"]=n["phone_number"]=""
        n["education_period_start"]=n["education_period_end"]=n["know_KT"]=new Date()

        work_exp.map((item,i)=>{
            if (work_exp.length>0){
                work_exp[i]["job_title"] = ""
                work_exp[i]["company_name"] = ""
                work_exp[i]["job_level"] = ""
                work_exp[i]["job_function"] = ""
                work_exp[i]["industry"] = ""
                work_exp[i]["key_responsibility"] = ""
                work_exp[i]["work_period_start"] = new Date()
                work_exp[i]["work_period_end"] = new Date()
                work_exp[i]["still_work"] = ""
                this.setState({work_exp})
               }
        })
        const element = document.getElementById("content2");
        element.scrollIntoView(0,0);
        this.setState({n, cv:"", job_function_id:"", industry_id:"",check:1, cv_filename:""})
        this.props.closeModal(false)
    }

    showPass=(e,y)=>{
        if (y==="new_pass"){
            this.setState({new_pass:e})
        }else{
            this.setState({confirm_pass:e})
        }
    }

    onChangeWorkStart = (work_period_start) => {
        this.setState({ work_period_start});
      };

    onChangeWorkEnd = (work_period_end) => {
    this.setState({ work_period_end });
    };

    setPosition=(e, n)=>{
       if (n[e]!==""){
        const el = document.getElementById(e)
        const top = el.offsetTop
        const n={el:el,top:top}
        return n
       }
    }


    continue=(e)=>{
        const n = this.state.data_job
        let {work_exp} = this.state
        let work_exp_err =[]
        let list_position=[]
        let list_element =[]
        const regEmail =  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

        let err_email = ""
        n["full_name_err"]=required(n["full_name"])
        err_email=required(n["email"])
        n["currently_working_err"]=required(n["currently_working"])
        n["password_err"]=required(n["password"])
        n["phone_number_err"]=required(n["phone_number"])
        n["gender_err"]=required(n["gender"])
        n["birth_date_err"]=required(n["birth_date"])
        n["country_id_err"]=required(n["country_id"])
        n["state_id_err"]=required(n["state_id"])
        n["city_id_err"]=required(n["city_id"])
        n["educational_stage_err"]=required(n["educational_stage"])
        n["institution_name_err"]=required(n["institution_name"])
        n["degree_err"]=required(n["degree"])
        n["CV_err"]=required(this.state.cv)
        n["know_KT_err"]=required(n["know_KT"])
        n["job_title_err"]=required(n["job_title"])
        n["company_name_err"]=required(n["company_name"])
        n["job_function_err"]=required(n["job_function"])
        n["job_level_err"]=required(n["job_level"])
        n["industry_err"]=required(n["industry"])
        n["industry_id_err"]=required(this.state.industry_id)
        n["job_function_id_err"]=required(this.state.job_function_id)
        n["key_responsibility_err"]=required(n["key_responsibility"])
        n["job_id"]=e
        let workcheck = true
        work_exp.map((item,i)=>{
            if (work_exp.length>0){
                work_exp[i]["job_title_err"] = required(work_exp[i]["job_title"])
                work_exp[i]["company_name_err"] = required(work_exp[i]["company_name"])
                work_exp[i]["job_level_err"] = required(work_exp[i]["job_level"])
                work_exp[i]["job_function_err"] = required(work_exp[i]["job_function"])
                work_exp[i]["industry_err"] = required(work_exp[i]["industry"])
                work_exp[i]["key_responsibility_err"] = required(work_exp[i]["key_responsibility"])
                let z = ["job_title_err","company_name_err","job_level_err","job_function_err","industry_err","key_responsibility_err"]
                this.setState({work_exp})
                
                z.map((y)=>{
                    if (work_exp[i][y] !==""){
                        list_position.push(this.setPosition(`${y}${i}`,work_exp[i]).top )
                        list_element.push(this.setPosition(`${y}${i}`,work_exp[i]).el)
                    }
                })

                let {expanded_work} = this.state

                if(work_exp[i]["job_title_err"] || work_exp[i]["company_name_err"]|| work_exp[i]["job_level_err"] || work_exp[i]["job_function_err"] || work_exp[i]["industry_err"] || work_exp[i]["key_responsibility_err"]) {
                    expanded_work[i] = true
                    this.setState({expanded_work})
                    workcheck = false
                }

                return(
                    work_exp_err.push(item.job_title_err, item.company_name_err, item.job_level_err, item.job_function_err,
                        item.industry_err, item.key_responsibility_err)
                )}
        })

        if (err_email !== ""  || String(n["email"]).toLowerCase().match(regEmail) === null){
            n["email_err"]= "invalid email address"
        }else{
            n["email_err"]=""
        }
        let list_id = ["currently_working_err","full_name_err","email_err","phone_number_err","gender_err","birth_date_err","country_id_err","city_id_err",
        "educational_stage_err","institution_name_err","degree_err","CV_err","know_KT_err","job_function_id_err","industry_id_err" ]
        
        list_id.map((item)=>{
            if (n[item]!==""){
            list_position.push(this.setPosition(item,this.state.data_job).top)
            list_element.push(this.setPosition(item,this.state.data_job).el)
        }})

        const zn = Math.min.apply(null,list_position)
        const index = list_position.indexOf(zn)


        if (n["full_name_err"] || n["email_err"] || n["currently_working_err"]  || n["phone_number_err"] || n["gender_err"] || n["birth_date_err"] || n["job_function_id_err"]
            || n["country_id_err"] || n["state_id_err"] || n["city_id_err"] || n["educational_stage_err"] || n["institution_name_err"] 
            || n["degree_err"]  || n["know_KT_err"] || n["industry_id_err"] || n["CV_err"] !="" || !workcheck){
                this.setState({n})
                list_element[index].scrollIntoView()


            }else{
                GAevent(`Continue to apply job - ${window.location.pathname}`,'Job Detail Public') 
                this.setState({check:2})
                const element = document.getElementById("content2");
                element.scrollIntoView(0,0);
            }

    }



    signUp=(e)=>{
        const n = this.state.data_job
        const {work_exp} = this.state
        const regEmail =  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        const passwordLength = /^(?=.*[\d]{1,})(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[~!@#$/€£¥%&^|+*)(}{><.,?})]).{8,16}$/;

        let err_email = ""
        let err_password =""
        let check_pass1=""
        let check_pass2=""
        n["full_name_err"]=required(n["full_name"])
        err_email=required(n["email"])
        check_pass1=required(n["password"])
        check_pass2=required(n["confirm_password"])

        if (err_email !== ""  || String(n["email"]).toLowerCase().match(regEmail) === null){
            n["email_err"]= "invalid email address"
        }else{
            n["email_err"]=""
        }
        if (check_pass2===""){
            err_password=check_pass1
        }else{
            err_password=check_pass2
        }

        if (err_password !==""){
            err_password = err_password
        }else if(!n["password"].match(passwordLength) ){
            err_password = "Password must be at least 8 characters contains a capital letter, a symbol, and a number";
        }else if (n["password"] !== n["confirm_password"]){
            err_password = "New Password and Confirm Password must be the same"
        }else{
            err_password=""
        }

        n["password_err"]=err_password

        if (n["full_name_err"] || n["email_err"] || n["password_err"] ){
                this.setState({n})
        }else{
        let work_exp_final = []
        work_exp.map((item) => {
        if(item.job_title && item.company_name && item.work_period_start && item.work_period_end && item.job_level && item.job_function && item.industry) {
            work_exp_final.push({
            job_title:item.job_title,
            company_name:item.company_name,
            work_period_start:item.work_period_start,
            work_period_end:item.work_period_end,
            still_work:item.still_work,
            job_level:item.job_level,
            job_function_id:item.job_function,
            industry_id:item.industry,
            key_responsibility:item.key_responsibility,
            })
        }
        })
        const data ={
            currently_working:n["currently_working"],
            full_name:n["full_name"],
            email:n["email"],
            password:n["password"],
            phone_number:n["phone_number"],
            gender:n["gender"],
            birth_date:n["birth_date"],
            area_residence:n["area"],
            country:n["country_id"],
            province:n["state_id"],
            city:n["city_id"],
            latest_salary:n["latest_salary"],
            expected_salary:n["expected_salary"],
            educational_stage:n["educational_stage"],
            institution_name:n["institution_name"],
            education_period_start:n["education_period_start"]!==undefined ?n["education_period_start"]:new Date(),
            education_period_end:n["education_period_end"]!==undefined ?n["education_period_end"]:new Date(),
            degree:n["degree"],
            still_study:n["still_study"],
            job_id:n["job_id"],
            CV:this.state.cv,
            cv_filename:this.state.cv_filename,
            know_KT:n["know_KT"],
            job_function_id:this.state.job_function_id,
            industry_id:this.state.industry_id,
            job: work_exp_final
                // work_exp.map((item,i)=>({
                //     job_title:item.job_title,
                //     company_name:item.company_name,
                //     work_period_start:item.work_period_start,
                //     work_period_end:item.work_period_end,
                //     still_work:item.still_work,
                //     job_level:item.job_level,
                //     job_function_id:item.job_function,
                //     industry_id:item.industry,
                //     key_responsibility:item.key_responsibility,
                // }))
            }

        data["email"] = CryptoJS.TripleDES.encrypt(data["email"], key, { iv: iv, mode: CryptoJS.mode.CBC }).toString()
        data["password"] = CryptoJS.TripleDES.encrypt(data["password"], key, { iv: iv, mode: CryptoJS.mode.CBC}).toString()
        // console.log("data /api/profile-apply= ",data);
        axios.post(`${API}/api/profile-apply`,data)
        .then(res => {
            this.setState({check:3})
            const element = document.getElementById("content2");
            element.scrollIntoView(0,0);
            const job = {
                user_id: res.data.user_id,
                job_opportunity_id :n["job_id"],
              };
              GAevent(`Sign Up to apply job - ${window.location.pathname}`,'Job Detail Public') 
              axios
              .post(`${API}/api/user_apply_job`,job).then(ress => {
             }
             )
        }   
        ).catch(err=>{
            this.setState({failed:true})
        })
    }
    }

    handleChangePDF = (info) => {
        if (info.file.status === "uploading") {
          this.setState({ cv:"..." });
          return;
        }
    
        if (info.file.status === "done") {
          // Get this url from response in real world.
          this.setState({ cv: info.file.name });
        }
      };


    uploadCV = async (client_logo, fields) => {
        let formData = new FormData();
        if(client_logo) formData.append("files", client_logo);
        this.setState({ cv_filename: client_logo.name });
        axios
            .post(`${API}/api/user_document/document/stand`,formData).then(res => {
                this.setState({ cv: res.data.file_name });
            }).catch(err=>{
                console.log(err,"error");
            })
        }
      

        compare( a, b ) {
            if ( a.state_name < b.state_name){
              return -1;
            }
            if ( a.state_name > b.state_name ){
              return 1;
            }
            return 0;
          }
          
        selectField=(e,y)=>{
            let z = false
            e.map(a=>{
            if (a===y){
                return(z=true)
            }})
            return z
        }

        disabledField=(e,y)=>{
            let z = false
            e.map(a=>{
            if (a!=y){
                return(z=true)
            }})
            return z
        }

        //   objs.sort( compare );
    render() {
        const {dataJobDetailPublic} = this.props
        const {dataCountry} = this.props.country1;
        const {dataProvince} = this.props.province1;
        const bn = dataProvince.sort((a,b) => a.state_name - b.state_name);
        const dataProvince_ = dataProvince.sort( this.compare )
        const {dataCity} = this.props.city1;
        const {dataIndustri} = this.props.industri1;
        const {dataJobLevel} = this.props.jobLevel1;
        const {dataJobFunction} = this.props.jobFunction1;
        const {dataJobType} = this.props.jobType1;
        const { listEdu } = this.props.list1;
        const { data_job, check,work_exp, cv, cv_filename,still_study,still_work, kt,fill_out, expanded_work, industry_id,
            job_function_id, job_level_id, new_pass, confirm_pass, work_period_start} = this.state
        const height = parseInt(window.innerHeight)
        const show = <svg className='pass' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29081 8.2301C6.16485 6.67673 8.89049 5 12 5C15.1096 5 17.8352 6.67673 19.7093 8.2301C20.6605 9.01854 21.4278 9.8047 21.9576 10.3937C22.2232 10.6888 22.4306 10.9362 22.5732 11.1119C22.6446 11.1997 22.6998 11.2698 22.7381 11.3191C22.7573 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7573 12.6562 22.7381 12.6809C22.6998 12.7302 22.6446 12.8003 22.5732 12.8881C22.4306 13.0638 22.2232 13.3112 21.9576 13.6063C21.4278 14.1953 20.6605 14.9815 19.7093 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89049 19 6.16485 17.3233 4.29081 15.7699C3.33961 14.9815 2.57232 14.1953 2.04245 13.6063C1.77694 13.3112 1.56952 13.0638 1.42688 12.8881C1.35553 12.8003 1.30028 12.7302 1.26198 12.6809C1.24282 12.6562 1.22789 12.6367 1.21729 12.6228L1.20465 12.6061L1.20079 12.601L1.19948 12.5992C1.19927 12.599 1.19858 12.598 2.00005 12C1.19858 11.402 1.19877 11.4017 1.19898 11.4014L1.20079 11.399L1.20465 11.3939L1.21729 11.3772C1.22789 11.3633 1.24282 11.3438 1.26198 11.3191C1.30028 11.2698 1.35553 11.1997 1.42688 11.1119C1.56952 10.9362 1.77694 10.6888 2.04245 10.3937C2.57232 9.8047 3.33961 9.01854 4.29081 8.2301ZM2.00005 12L1.19898 11.4014C0.934264 11.7562 0.933867 12.2433 1.19858 12.598L2.00005 12ZM3.29224 12C3.364 12.083 3.44313 12.1729 3.52934 12.2687C4.01152 12.8047 4.7087 13.5185 5.56714 14.2301C7.31239 15.6767 9.58675 17 12 17C14.4133 17 16.6877 15.6767 18.433 14.2301C19.2914 13.5185 19.9886 12.8047 20.4708 12.2687C20.557 12.1729 20.6361 12.083 20.7079 12C20.6361 11.917 20.557 11.8271 20.4708 11.7313C19.9886 11.1953 19.2914 10.4815 18.433 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58675 7 7.31239 8.32327 5.56714 9.7699C4.7087 10.4815 4.01152 11.1953 3.52934 11.7313C3.44313 11.8271 3.364 11.917 3.29224 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.50005 12C8.50005 10.067 10.0671 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.0671 15.5 8.50005 13.933 8.50005 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8285 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8285 10.5 12 10.5Z" fill="#292929"/>
                    </svg>
       
        const hide = <svg className='pass' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4.29081 8.2301C6.16485 6.67673 8.89049 5 12 5C15.1096 5 17.8352 6.67673 19.7093 8.2301C20.6605 9.01854 21.4278 9.8047 21.9576 10.3937C22.2232 10.6888 22.4306 10.9362 22.5732 11.1119C22.6446 11.1997 22.6998 11.2698 22.7381 11.3191C22.7573 11.3438 22.7722 11.3633 22.7828 11.3772L22.7954 11.3939L22.7993 11.399L22.8006 11.4008C22.8008 11.401 22.8015 11.402 22 12C22.8015 12.598 22.8013 12.5983 22.8011 12.5986L22.7993 12.601L22.7954 12.6061L22.7828 12.6228C22.7722 12.6367 22.7573 12.6562 22.7381 12.6809C22.6998 12.7302 22.6446 12.8003 22.5732 12.8881C22.4306 13.0638 22.2232 13.3112 21.9576 13.6063C21.4278 14.1953 20.6605 14.9815 19.7093 15.7699C17.8352 17.3233 15.1096 19 12 19C8.89049 19 6.16485 17.3233 4.29081 15.7699C3.33961 14.9815 2.57232 14.1953 2.04245 13.6063C1.77694 13.3112 1.56952 13.0638 1.42688 12.8881C1.35553 12.8003 1.30028 12.7302 1.26198 12.6809C1.24282 12.6562 1.22789 12.6367 1.21729 12.6228L1.20465 12.6061L1.20079 12.601L1.19948 12.5992C1.19927 12.599 1.19858 12.598 2.00005 12C1.19858 11.402 1.19877 11.4017 1.19898 11.4014L1.20079 11.399L1.20465 11.3939L1.21729 11.3772C1.22789 11.3633 1.24282 11.3438 1.26198 11.3191C1.30028 11.2698 1.35553 11.1997 1.42688 11.1119C1.56952 10.9362 1.77694 10.6888 2.04245 10.3937C2.57232 9.8047 3.33961 9.01854 4.29081 8.2301ZM2.00005 12L1.19898 11.4014C0.934264 11.7562 0.933867 12.2433 1.19858 12.598L2.00005 12ZM3.29224 12C3.364 12.083 3.44313 12.1729 3.52934 12.2687C4.01152 12.8047 4.7087 13.5185 5.56714 14.2301C7.31239 15.6767 9.58675 17 12 17C14.4133 17 16.6877 15.6767 18.433 14.2301C19.2914 13.5185 19.9886 12.8047 20.4708 12.2687C20.557 12.1729 20.6361 12.083 20.7079 12C20.6361 11.917 20.557 11.8271 20.4708 11.7313C19.9886 11.1953 19.2914 10.4815 18.433 9.7699C16.6877 8.32327 14.4133 7 12 7C9.58675 7 7.31239 8.32327 5.56714 9.7699C4.7087 10.4815 4.01152 11.1953 3.52934 11.7313C3.44313 11.8271 3.364 11.917 3.29224 12ZM22 12L22.8011 12.5986C23.0658 12.2438 23.0662 11.7567 22.8015 11.402L22 12ZM8.50005 12C8.50005 10.067 10.0671 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.0671 15.5 8.50005 13.933 8.50005 12ZM12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8285 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8285 10.5 12 10.5Z" fill="#292929"/>
                        <line x1="19.7231" y1="4.29703" x2="3.9604" y2="20.0598" stroke="#292929" stroke-width="2" stroke-linecap="round"/>
                        </svg>       

        const steps = <div className='p-2421 bg-f9' id="content2">
                <div className='flex column hg-54 width-auto p-023'>
                    <div className='flex width-100 hg-4 bg-d4 mt-25 --b'>
                        <div className='hg-100 bg-36 '/>
                    </div>
                    <div className='flex width-100 space-between mt--29'>
                        <div className={`wd-54 hg-54 flex br-100 ${check>0?`bg-36`:`bg-d4`}`} >
                            <svg className='auto' width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4665 9.5743C14.4563 10.5962 13.22 11.1142 11.7922 11.1142C10.3648 11.1142 9.12861 10.5961 8.11828 9.57447C7.10795 8.55269 6.5957 7.30231 6.5957 5.85797C6.5957 4.41395 7.10795 3.16358 8.11812 2.1418C9.12829 1.12002 10.3643 0.602051 11.7922 0.602051C13.2198 0.602051 14.456 1.12002 15.4663 2.14163C16.4767 3.16374 16.9887 4.41412 16.9887 5.85797C16.9887 7.30231 16.4767 8.55252 15.4665 9.5743ZM20.7816 17.6227C20.8683 18.1125 20.9272 18.5764 20.9564 19.0016C20.9852 19.4172 20.9998 19.8509 21 20.2906C21 21.4303 20.642 22.3527 19.9358 23.0323C19.2384 23.7036 18.3161 24.0439 17.1942 24.0439H6.80579C5.68385 24.0439 4.76125 23.7034 4.06399 23.0323C3.35801 22.3522 3 21.4299 3 20.2908C3 19.8531 3.01449 19.4197 3.04313 19.0021C3.07226 18.5759 3.13119 18.1119 3.21793 17.6227C3.3055 17.1292 3.41826 16.6629 3.55307 16.2365C3.69265 15.7954 3.88227 15.3604 4.1165 14.9433C4.35946 14.5106 4.64537 14.1338 4.96585 13.8234C5.30148 13.4986 5.71216 13.2377 6.18655 13.0477C6.65945 12.8583 7.18355 12.7622 7.74452 12.7622C7.96476 12.7622 8.17792 12.8536 8.58877 13.1245C8.84571 13.2938 9.142 13.487 9.46939 13.6986C9.75169 13.8807 10.1346 14.0514 10.607 14.2057C11.0688 14.3567 11.5371 14.4333 11.9995 14.4333C12.4619 14.4333 12.9303 14.3567 13.3917 14.2057C13.8646 14.0512 14.2475 13.8806 14.5301 13.6984C14.8606 13.4848 15.1568 13.2917 15.4099 13.1247C15.8213 12.8538 16.0343 12.7624 16.2545 12.7624C16.8153 12.7624 17.3396 12.8583 17.8126 13.0476C18.2873 13.2379 18.6979 13.4988 19.0332 13.8233C19.3538 14.1335 19.6396 14.5104 19.8828 14.9433C20.1172 15.3604 20.3069 15.7956 20.4463 16.2363C20.5812 16.6627 20.694 17.1292 20.7816 17.6227Z" fill="white"/>
                            </svg>
                        </div>
                        <div className={`wd-54 hg-54 flex br-100 ${ check>1?`bg-36`:`bg-d4`}`} >
                            <svg className='auto' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.5 21H15.5625C15.2531 21 15 20.7469 15 20.4375V18.5625C15 18.2531 15.2531 18 15.5625 18H19.5C20.3297 18 21 17.3297 21 16.5V7.5C21 6.67031 20.3297 6 19.5 6H15.5625C15.2531 6 15 5.74688 15 5.4375V3.5625C15 3.25313 15.2531 3 15.5625 3H19.5C21.9844 3 24 5.01563 24 7.5V16.5C24 18.9844 21.9844 21 19.5 21ZM17.2969 11.5781L9.42188 3.70313C8.71875 3 7.5 3.49219 7.5 4.5V9H1.125C0.501562 9 0 9.50156 0 10.125V14.625C0 15.2484 0.501562 15.75 1.125 15.75H7.5V20.25C7.5 21.2578 8.71875 21.75 9.42188 21.0469L17.2969 13.1719C17.7328 12.7313 17.7328 12.0188 17.2969 11.5781Z" fill="white"/>
                            </svg>
                        </div>
                        <div className={`wd-54 hg-54 flex br-100 ${ check>2?`bg-36`:`bg-d4`}`} >
                            <svg className='auto' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M23.5453 8.94375C23.7281 8.79844 24 8.93437 24 9.16406V18.75C24 19.9922 22.9922 21 21.75 21H2.25C1.00781 21 0 19.9922 0 18.75V9.16875C0 8.93438 0.267187 8.80312 0.454687 8.94844C1.50469 9.76406 2.89688 10.8 7.67813 14.2734C8.66719 14.9953 10.3359 16.5141 12 16.5047C13.6734 16.5188 15.375 14.9672 16.3266 14.2734C21.1078 10.8 22.4953 9.75938 23.5453 8.94375ZM12 15C13.0875 15.0188 14.6531 13.6313 15.4406 13.0594C21.6609 8.54531 22.1344 8.15156 23.5687 7.02656C23.8406 6.81562 24 6.4875 24 6.14062V5.25C24 4.00781 22.9922 3 21.75 3H2.25C1.00781 3 0 4.00781 0 5.25V6.14062C0 6.4875 0.159375 6.81094 0.43125 7.02656C1.86563 8.14687 2.33906 8.54531 8.55938 13.0594C9.34688 13.6313 10.9125 15.0188 12 15Z" fill="white"/>
                            </svg>
                        </div>
                        <div className='wd-54 hg-54 flex bg-d4 br-100'>
                            <svg className='auto' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.3859 4.63043C13.874 4.63043 11.7994 2.99998 8.64131 2.99998C7.47155 2.99998 6.4237 3.20548 5.4517 3.56309C5.58641 3.21128 5.64374 2.83458 5.6198 2.45862C5.53673 1.12569 4.44403 0.0565147 3.10959 0.00223349C1.60992 -0.0587977 0.375 1.13886 0.375 2.62498C0.375 3.51683 0.820172 4.30428 1.5 4.77865V22.875C1.5 23.4963 2.00367 24 2.625 24H3.375C3.99633 24 4.5 23.4963 4.5 22.875V18.45C5.82708 17.8845 7.48041 17.413 9.86414 17.413C12.3761 17.413 14.4506 19.0435 17.6087 19.0435C19.8666 19.0435 21.6712 18.2797 23.3511 17.1282C23.7581 16.8493 24 16.3861 24 15.8927V4.4974C24 3.40086 22.8624 2.67537 21.8679 3.13728C20.2583 3.88484 18.2841 4.63043 16.3859 4.63043Z" fill="white"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='flex width-100 space-between mt-16 mob-p'>
                    <p className='s-14 c-29 w-600 OpenSans wd_100 align-center'>Fill Out Your Profile</p>
                    <p className='s-14 c-29 w-600 OpenSans wd_100 align-center'>Sign Up</p>
                    <p className='s-14 c-29 w-600 OpenSans wd_100 align-center'>Verify Email</p>
                    <p className='s-14 c-29 w-600 OpenSans wd_100 align-center'>Job Applied</p>
                </div>
            </div>
    
    const pdfFileDekstop = {
        id: this.state.id,
        name: "files",
        method: "post",
        action:  `${API}/api/user_document/document/stand`,
        onChange(info) {
        if (info.file.status === 'done') {
            message.success(`${info.file.name} file uploaded successfully`);
        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);
        }
        },
    };

        return (
            <React.Fragment>
                <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1.0,minimum-scale=1.0, maximum-scale=1.0, user-scalable=0" />
                </Helmet>
                {dataJobDetailPublic.map((item,i)=>(
                <div className='flex column wd-job-apply bg-ff br-5' style={{height:`${height * 0.9}px`}} >
                    <div className='flex width-100 column bg-ff shd_ br-5'>
                        <div className='p-1424'>
                            <p className='s-1419 c-29 mb-14 openSans'>You are applying</p>
                            <div className='flex space-between mb-10'>
                                <div className='flex'>
                                    <img src={item.photo !=null? `${API}/File/Job_Opportunity/${item.photo}`: default_company} className="icon mr-26 cover flex" />
                                    <div className='flex column '>
                                        <p className='c-54 s-14 mb4'>{item.company} </p>
                                        <p className='w-600 s-20 c-36'>{item.job_title} </p>
                                    </div>
                                </div>
                                <button className='p-818 flex bg-ff s-14 bd-ea c-29 br-16 hg-fit-content' onClick={()=>this.props.closeModal(false)}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className='flex column scr_ overflow' >
                        {steps}
                        <div className={`column width-100 ${check===1?"flex":"none"}`} ref={ (ref) => this.myRef=ref }>
                        <div className='bg-15 flex width-100 mt-24'>
                            <div className='flex-mob m-15auto'>
                                <p className='s-14 w-600 c-29'>Already have Karya Talents account? &nbsp;</p>
                                <p className='s-14 w-600 c-36 pointer' onClick={() => window.location.href="/login"}>Sign in</p>
                            </div>
                        </div>
                        <div className='flex column p-24' id="currently_working_err">
                        <i className='OpenSans w-400 s-16 c-29 align-center p-014 mb-48'>You only need to fill out all the information on the profile below once,
                            and you can apply to all of our jobs afterward.</i>
                            <div className="flex-mob width-100 space-between mb-24" >
                                <p className='OpenSans c-29 s-16 auto-00'>Are you currently working?</p>
                                <div className='flex mt-14-mob'>
                                    <div className="flex mr-48">
                                        <Radio className='mr-10' id="ck1" value={data_job["currently_working"]} checked={data_job["currently_working"] === 1} onChange={()=>this.setData(1,"currently_working")} color="default" name="radio-buttons"/>
                                        <p className=' s-14 c-29 auto-00' onClick={()=>this.setData(1,"currently_working")}>Yes</p>
                                    </div>
                                    <div className="flex">
                                        <Radio className='mr-10' id="ck2" value={data_job["currently_working"]} checked={data_job["currently_working"] === 0} onChange={()=>this.setData(0,"currently_working")} color="default" name="radio-buttons"/>
                                        <p className=' s-14 c-29 auto-00' onClick={()=>this.setData(0,"currently_working")}>No</p>
                                    </div>
                                </div>
                            </div>
                            <p className='c-red s-12'>{data_job["currently_working_err"]} </p>
                        </div>
                        <div className='list-item width-100 hg-6 bg-ea'/>
                        <div className='flex column p-24'>
                            <p className='w-bold s-16 c-29 mb-24'>Basic Information</p>
                            <div className='flex-mob width-100 space-between' id="full_name_err">
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Full Name</p>
                                        <input type='text' value={data_job["full_name"]} onChange={(e)=>(this.setData(e.target.value,"full_name"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{data_job["full_name_err"]} </p>
                                    </div>
                                </div>
                                <div className='wd-264 flex column' id="email_err">
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Email</p>
                                        <input type='text' value={data_job["email"]} onChange={(e)=>(this.setData(e.target.value,"email"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{data_job["email_err"]} </p>
                                    </div>
                                </div>
                            </div>
                            <div className='flex-mob width-100 space-between' id="phone_number_err">
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Phone Number</p>
                                        <input type='text' value={data_job["phone_number"]} onChange={(e)=>(this.setData(e.target.value,"phone_number"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{data_job["phone_number_err"]} </p>
                                    </div>
                                </div>
                                <div className='wd-264 flex column' id="gender_err">
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Gender</p>
                                        <div className='flex hg-48'>
                                            <div className="flex mr-48">
                                                <Radio className='mr-10' id="ck1" checked={data_job["gender"] === 1} onChange={()=>this.setData(1,"gender")} color="default" name="radio-buttons"/>
                                                <p className=' s-14 c-29 auto-00' onClick={()=>this.setData(1,"gender")}>Male</p>
                                            </div>
                                            <div className="flex">
                                                <Radio className='mr-10' id="ck2" checked={data_job["gender"] === 2} onChange={()=>this.setData(2,"gender")} color="default" name="radio-buttons"/>
                                                <p className=' s-14 c-29 auto-00' onClick={()=>this.setData(2,"gender")}>Female</p>
                                            </div>
                                        </div>
                                        <p className='c-red s-12'>{data_job["gender_err"]} </p>
                                    </div>
                                </div>
                            </div>
                            <div className='flex-mob width-100 space-between' >
                                <div className='wd-264 flex column' id="birth_date_err">
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Birth Date</p>
                                        {/* <input type='date' value={data_job["birth_date"]} onChange={(e)=>(this.setData(e.target.value,"birth_date"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' /> */}
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker   className=' s-16 OpenSans width-100 w-90 flex out-none  bd-ea br-5 shd_'
                                                id="birth_date"
                                                name="birth_date"
                                                format='dd/MM/yyyy'
                                                value={data_job["birth_date"] === undefined?new Date():data_job["birth_date"]}
                                                onChange={(e)=>(this.setData(e,"birth_date"))}
                                                // onChange={(e)=>(this.changeWork(e,"work_period_start",i))}
                                                ref={this.input}
                                                maxDate={new Date()}
                                                KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                                }}
                                                />
                                                </MuiPickersUtilsProvider>
                                        <p className='c-red s-12'>{data_job["birth_date_err"]} </p>
                                    </div>
                                </div>
                                <div className='wd-264 flex column' id="area_err">
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans flex width-100'>Area of Residence &nbsp;<p className='s-16 c-a9 OpenSans w-400'>(optional)</p></p>
                                        <input type='text' value={data_job["area"]} onChange={(e)=>(this.setData(e.target.value,"area"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{data_job["area_err"]} </p>
                                    </div>
                                </div>
                            </div>
                            <div className='flex-mob width-100 space-between' >
                                <div className='wd-264 flex column' id="country_id_err">
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans' >Country</p>
                                        <select type='text' value={data_job["country_id"]} onChange={(e)=>(this.setData(e.target.value,"country_id"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' >
                                            <option disabled selected value={""} style={{display:"none"}}> Select Country</option>
                                            {dataCountry.map((item,i)=>
                                            <option value={item.id}>{item.country_name} </option>
                                            )}
                                        </select>
                                        <p className='c-red s-12'>{data_job["country_id_err"]} </p>
                                    </div>
                                </div>
                                <div className='wd-264 flex column' id="state_id_err">
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Province</p>
                                        <select type='text' value={data_job["state_id"]} onChange={(e)=>(this.setData(e.target.value,"state_id"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' >
                                            <option disabled selected value={""} style={{display:"none"}}> Select Province</option>
                                            {dataProvince_.map((item,i)=>(
                                            <option value={item.id} >{item.state_name} </option>
                                            ))}
                                        </select>
                                        <p className='c-red s-12'>{data_job["state_id_err"]} </p>
                                    </div>
                                </div>
                            </div>
                            <div className='flex-mob width-100 space-between' id="city_id_err">
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>City</p>
                                        <select type='text' value={data_job["city_id"]} onChange={(e)=>(this.setData(e.target.value,"city_id"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' >
                                            <option disabled selected value={""} style={{display:"none"}}> Select City</option>
                                            {dataCity.map((item,i)=>(
                                            <option value={item.id}>{item.city_name} </option>
                                            ))}
                                        </select>
                                        <p className='c-red s-12'>{data_job["city_id_err"]} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='list-item width-100 hg-6 bg-ea'/>
                        <div className='flex column p-24'>
                            <p className='w-bold s-16 c-29 mb-24 flex'>Salary &nbsp;<p className='s-16 c-a9 OpenSans w-400'>(optional)</p> </p>
                            <div className='bd-187 bg-82 br-5 p-1014 mb-24'>
                                <p className='OpenSans c-29 w-400 s-14'>We recommend you to fill this out so that we can match you to suitable opportunities</p>
                            </div>
                            <div className='flex-mob width-100 space-between'>
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Latest Salary</p>
                                        <input type='text' value={data_job["latest_salary"] !==undefined?priceSplitter(data_job["latest_salary"]*1):""} onChange={(e)=>(this.setData(e.target.value,"latest_salary"))} className=' s-16 OpenSans p-1140  flex out-none bd-ea br-5 shd_' />
                                        <p className='s-16 openSans rp__ c-29 ml-14 wd-fit-content'>Rp</p>
                                    </div>
                                    {/* <p className='c-red s-12'>{data_job["_err"]} </p> */}
                                </div>
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Expected Salary</p>
                                        <input type='text' value={data_job["expected_salary"] !==undefined?priceSplitter(data_job["expected_salary"]*1):""} onChange={(e)=>(this.setData(e.target.value,"expected_salary"))} className=' s-16 OpenSans p-1140 flex out-none bd-ea br-5 shd_' />
                                        <p className='s-16 openSans rp__ c-29 ml-14 wd-fit-content'>Rp</p>
                                    </div>
                                    {/* <p className='c-red s-12'>{data_job["expected_salary_err"]} </p> */}
                                </div>
                            </div>
                        </div>
                        <div className='list-item width-100 hg-6 bg-ea'/>
                        <div className='flex column p-24'>
                            <p className='w-bold s-16 c-29 mb-24 flex'>Work Experience </p>
                            <div className='bd-187 bg-82 br-5 p-1014 mb-24'>
                                <p className='OpenSans c-29 w-400 s-14'>Put at least 3 of your latest experiences to officially join our talent network and get contacted by our recruiters</p>
                            </div>
                            {work_exp.map((item,i)=>(
                            <div className="width-100 flex" key={i} id="box-experience">
                            <Accordion className='width-100'   expanded={ expanded_work[i]===true }>
                            {/* <Accordion className='width-100'  onChange = {(e, expanded) => {
                                if(expanded_work[i]){
                                    console.log('expand =', expanded_work[i])
                                    this.expandedWork(expanded_work[i],i)
                                }
                            }} > */}
                                <AccordionSummary onClick={(e)=>this.expandedWork(!expanded_work[i],i)}
                                expandIcon={<ExpandMoreIcon />}
                                // onClick={this.changeRevert}
                                id="panel1a-header"
                                >
                                <p  >Experience {i+1}</p>
                                </AccordionSummary >
                                <div className='flex-mob width-100 space-between'>
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14' id={`job_title_err${i}`}>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Job Title</p>
                                        <input type='text' value={item.job_title} onChange={(e)=>(this.changeWork(e.target.value,"job_title",i))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{work_exp[i]["job_title_err"]}</p>
                                    </div>
                                    <div className='flex column width-100 mb-14' id={`company_name_err${i}`}>
                                        <p className='mb-10 c-29 w-400 OpenSans' >Company Name</p>
                                        <input type='text' value={item.company_name} onChange={(e)=>(this.changeWork(e.target.value,"company_name",i))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{work_exp[i]["company_name_err"]} </p>
                                    </div>
                                    <div className='flex column width-100 mb-14' >
                                        <p className='mb-10 c-29 w-400 OpenSans'>Work Period</p>
                                        <div className="width-100 flex space-between ">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker  views={["year", "month"]}  className=' s-16 OpenSans date-myprofile-left w-90 flex out-none  bd-ea br-5 shd_'
                                                id="work_period_start"
                                                name="work_period_start"
                                                value={item.work_period_start}
                                                // onChange={(e)=>(this.setData(e,"work_period_start"))}
                                                onChange={(e)=>(this.changeWork(e,"work_period_start",i))}
                                                ref={this.input}
                                                maxDate={new Date()}
                                                KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                                }}
                                                />
                                                </MuiPickersUtilsProvider>
                                                <div className="hyphen">-</div>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker  views={["year", "month"]}  className=' s-16 OpenSans date-myprofile-left w-90 flex out-none  bd-ea br-5 shd_'
                                                name="work_period_end"
                                                id="work_period_end"
                                                value={item.work_period_end}
                                                // onChange={(e)=>(this.setData(e,"work_period_end"))}
                                                onChange={(e)=>(this.changeWork(e,"work_period_end",i))}
                                                ref={this.input}
                                                maxDate={new Date()}
                                                KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                                }}
                                                />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                    </div>
                                    <div className='flex column width-100 mb-24'>
                                        <div className='flex width-100'>
                                            <input type='checkbox' 
                                            value={item.still_work} checked={item.still_work===1}
                                            onChange={(e)=>(this.changeWork(!still_work[i],"still_work",i))}
                                            className='mr-10 pointer' />
                                            <p className='OpenSans s-16 w-400 c-29' onClick={(e)=>(this.changeWork(!still_work[i],"still_work",i))}>I still work here</p>
                                        </div>
                                    </div>
                                    <div className='flex column width-100 mb-14'  id={`job_level_err${i}`}>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Job Level</p>
                                        <select type='text' value={item.job_level} onChange={(e)=>(this.changeWork(e.target.value,"job_level",i))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' >
                                            <option  disabled selected value={""} style={{display:"none"}}> Select Job Level</option>
                                            {dataJobLevel.map((item,i)=>(
                                                <option value={item.id}>{item.job_level_name} </option>
                                            ))}
                                        </select>
                                        <p className='c-red s-12'>{work_exp[i]["job_level_err"]} </p>
                                    </div>
                                    <div className='flex column width-100 mb-14' id={`job_function_err${i}`}>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Job Function</p>
                                        <select type='text' value={item.job_function} onChange={(e)=>(this.changeWork(e.target.value,"job_function",i))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' >
                                            <option disabled selected value={""} style={{display:"none"}}> Select Job Function</option>
                                            {dataJobFunction.map((item,i)=>(
                                            <option value={item.id}>{item.job_function_name} </option>
                                            ))}
                                        </select>
                                        <p className='c-red s-12'>{work_exp[i]["job_function_err"]} </p>
                                    </div>
                                    <div className='flex column width-100 mb-14' id={`industry_err${i}`}>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Industry</p>
                                        <select type='text' value={item.industry} onChange={(e)=>(this.changeWork(e.target.value,"industry",i))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' >
                                            <option disabled selected value={""} style={{display:"none"}}> Select Industry</option>
                                            {dataIndustri.map((item,i)=>(
                                                <option value={item.id}>{item.industry_name} </option>
                                            ))}
                                        </select>
                                        <p className='c-red s-12'>{work_exp[i]["industry_err"]} </p>
                                    </div>
                                </div>
                                <div className='wd-264 flex column' id={`key_responsibility_err${i}`}>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans' >Key Responsibilities</p>
                                        <div contentEditable dangerouslySetInnerHTML={{ __html: item.key_responsibility }} className=' s-16 column overflow OpenSans p-1114 flex out-none hg-500  bd-ea br-5 shd_' 
                                         onBlur={(e)=>(this.changeWork(e.currentTarget.textContent,"key_responsibility",i))}/>
                                        <p className='c-red s-12'>{work_exp[i]["key_responsibility_err"]} </p>
                                    </div>
                                </div>
                            </div>
                            </Accordion>
                            </div>
                            ))}
                            {/* <div className={`flex width-100   shd_  hg-48 br-5 mb-24 mt-14 ${work_exp.length>2?"bg-bd bd-ff":"bg-36 bd-36 pointer"}`} onClick={(e)=>this.addWork(work_exp.length,0)}>
                                <p className='c-ff w-bold OpenSans m-auto s-1421'>+ Add Work Experience</p>
                            </div> */}
                        </div>

                        <div className='list-item width-100 hg-6 bg-ea'/>
                        <div className='flex column p-24'>
                            <p className='w-bold s-16 c-29 mb-24 flex'>Latest Education</p>
                            <div className='flex-mob width-100 space-between'>
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14' id="educational_stage_err">
                                        <p className='mb-10 c-29 w-400 OpenSans'>Educational Stage</p>
                                        <select type='text' value={data_job["educational_stage"]} onChange={(e)=>(this.setData(e.target.value,"educational_stage"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' >
                                            <option disabled selected value={""} style={{display:"none"}}> Select Educational Stage</option>
                                            {listEdu.map((item,i)=>(
                                            <option value={item.id}>{item.education_name} </option>
                                            ))}
                                        </select>
                                        <p className='c-red s-12'>{data_job["educational_stage_err"]} </p>
                                    </div>
                                    <div className='flex column width-100 mb-14' id="education_period_err">
                                        <p className='mb-10 c-29 w-400 OpenSans '>Education Period</p>
                                        <div className="width-100 flex space-between ">
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker  views={["year", "month"]}  className=' s-16 OpenSans date-myprofile-left w-90 flex out-none  bd-ea br-5 shd_'
                                                id="education_period_start"
                                                name="education_period_start"
                                                value={ data_job["education_period_start"]}
                                                onChange={(e)=>(this.setData(e,"education_period_start"))}
                                                ref={this.input}
                                                maxDate={new Date()}
                                                KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                                }}
                                                />
                                                </MuiPickersUtilsProvider>
                                                <div className="hyphen">-</div>
                                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <DatePicker  views={["year", "month"]}  className='z_ s-16 OpenSans date-myprofile-right w-90 flex out-none  bd-ea br-5 shd_'
                                                name="work_period_end"
                                                id="work_period_end"
                                                value={data_job["education_period_end"]}
                                                onChange={(e)=>(this.setData(e,"education_period_end"))}
                                                ref={this.input}
                                                maxDate={new Date()}
                                                KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                                }}
                                                />
                                                </MuiPickersUtilsProvider>
                                            </div>
                                        <p className='c-red s-12'>{data_job["education_period_err"]} </p>
                                    </div>
                                    <div className='flex column width-100 mb-24'>
                                        <div className='flex width-100'>
                                            <input type='checkbox' value={1} checked={still_study===true} className='mr-10 pointer ' onChange={(e)=>(this.setData(!still_study,"still_study"))} />
                                            <p className='OpenSans s-16 w-400 c-29' value={1} onClick={(e)=>(this.setData(!still_study,"still_study"))}>I still study here</p>
                                        </div>
                                        <p className='c-red s-12'>{data_job["still_study_err"]} </p>
                                    </div>
                                </div>
                                <div className='wd-264 flex column' id="institution_name_err">
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Institution Name</p>
                                        <input type='text' value={data_job["institution_name"]} onChange={(e)=>(this.setData(e.target.value,"institution_name"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{data_job["institution_name_err"]} </p>
                                    </div>
                                    <div className='flex column width-100 mb-14' id="degree_err">
                                        <p className='mb-10 c-29 w-400 OpenSans'>Degree</p>
                                        <input type='text' value={data_job["degree"]} onChange={(e)=>(this.setData(e.target.value,"degree"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{data_job["degree_err"]} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='list-item width-100 hg-6 bg-ea'/>
                        <div className='flex width-100 column CV' >
                            <div className='p-24'>
                                <p className='w-bold s-16 c-29 mb-24 flex'>Add Your CV</p>
                                {/* <Upload {...pdfFileDekstop} accept=".doc, .docx, .pdf"> */}
                                {/* <Upload  {...pdfFileDekstop} accept=".doc, .docx, .pdf" onChange={this.handleChangePDF} method="post" action={`${API}/api/user_document/document/stand`}> */}
                                <label for='inputFile_job' >
                                <div className='flex width-100 bg-36 bd-36 shd_ hg-48 br-5 mt-14 mb-14 pointer' id="CV_err">
                                    <p className='c-ff w-bold OpenSans m-auto s-1421'>+ Attach file</p>
                                </div>
                                </label>
                                {/* </Upload> */}
                                <p className='OpenSans c-29 s-14 align-center mb-24'>Supported file extension: (doc,docx,pdf), Maximum file size is 10MB</p>
                                <p className='c-red s-12'>{data_job["CV_err"]} </p>
                            </div>
                        </div>
                        {cv_filename &&
                        <div className='flex width-100 hg-48 space-between bg-f9 mb-24'>
                            <div className='flex p-218'>
                                <p className='s-14 w-600 OpenSans c-29'>{cv_filename} </p>
                            </div>
                            <label for='inputFile_job'>
                            {/* <Upload {...pdfFileDekstop} accept=".doc, .docx, .pdf" onChange={this.handleChangePDF} method="post" action={`${API}/api/user_document/document/stand`}> */}
                            <div className='flex  bg-15 p-1424 hg-fit-content'>
                                <p className='s-14 w-600 OpenSans c-36 '>Choose another file</p>
                            </div>
                            {/* </Upload> */}
                            </label>
                        </div>}
                        {/* <input type='file' id="inputFile_job" className='none' onChange={(e)=>this.uploadCV(e.target.files[0], "CV")} accept=".doc, .docx,.pdf" /> */}
                        <input type='file' id="inputFile_job" className='none' onChange={(e)=>this.uploadCV(e.target.files[0],"CV")} accept=".doc, .docx,.pdf" />
                        <div className='list-item width-100 hg-6 bg-ea'/>
                        <div className='flex column width-100' id="know_KT_err">
                            <div className='p-24'>
                                <p className='w-bold s-16 c-29 mb-24 flex'>How do you know Karya Talents?</p>
                                <div className='flex-mob width-100'>
                                    <div className='flex column mr-46'>
                                        <div className="flex mb-14">
                                            <Radio className='mr-10' id="ck2" checked={data_job["know_KT"] === 'From a friend'} onChange={()=>this.setData("From a friend","know_KT")} color="default" name="radio-buttons"/>
                                            <p className=' s-14 c-29 auto-00' onClick={()=>this.setData("From a friend")}>From a friend</p>
                                        </div>
                                        <div className="flex mb-14">
                                            <Radio className='mr-10' id="ck2" checked={data_job["know_KT"] === 'LinkedIn'} onChange={()=>this.setData("LinkedIn","know_KT")} color="default" name="radio-buttons"/>
                                            <p className=' s-14 c-29 auto-00' onClick={()=>this.handleChange("B")}>LinkedIn</p>
                                        </div>
                                        <div className="flex mb-14">
                                            <Radio className='mr-10' id="ck2" checked={data_job["know_KT"] === 'Instagram Ad'} onChange={()=>this.setData("Instagram Ad","know_KT")} color="default" name="radio-buttons"/>
                                            <p className=' s-14 c-29 auto-00' onClick={()=>this.handleChange("B")}>Instagram Ad</p>
                                        </div>
                                    </div>
                                    <div className='flex column'>
                                        <div className="flex mb-14">
                                            <Radio className='mr-10' id="ck2" checked={data_job["know_KT"] === 'Facebook Ad'} onChange={()=>this.setData("Facebook Ad","know_KT")} color="default" name="radio-buttons"/>
                                            <p className=' s-14 c-29 auto-00' onClick={()=>this.handleChange("B")}>Facebook Ad</p>
                                        </div>
                                        <div className="flex mb-14">
                                            <Radio className='mr-10' id="ck2" checked={data_job["know_KT"] === 'Contacted directly by Karya Talents’ team'} onChange={()=>this.setData("Contacted directly by Karya Talents’ team","know_KT")} color="default" name="radio-buttons"/>
                                            <p className=' s-14 c-29 auto-00' onClick={()=>this.handleChange("B")}>Contacted directly by Karya Talents’ team</p>
                                        </div>
                                        <div className='flex column mb-14'>
                                        <div className="flex ">
                                            <Radio className='mr-10' id="ck2" checked={data_job["know_KT"] === kt  } onChange={()=>this.setData(kt,"know_KT")} color="default" name="radio-buttons"/>
                                            <div className=' s-14 c-29 auto-00 wd-200 out-none bd-bottom-29' contentEditable onBlur={(e)=>{this.setState({kt:e.currentTarget.textContent}) 
                                            this.setData(e.currentTarget.textContent,"know_KT")}} onInput={(e)=>{this.setState({kt:e.currentTarget.textContent}) 
                                            this.setData(e.currentTarget.textContent,"know_KT")}}></div>
                                        </div>
                                        <p className='c-red s-12 ml-40'>{fill_out} </p>
                                        </div>
                                    </div>
                                </div>
                                <p className='c-red s-12'>{data_job["know_KT_err"]} </p>
                            </div>
                        </div>
                        <div className='list-item width-100 hg-6 bg-ea'/>
                        <div className='p-24' id="job_function_id_err">
                            <p className='w-bold s-16 c-29 mb-24 flex'>Which Job Functions are you interested in?</p>
                            <div className='flex width-100 wrap jobFunction'>
                                <div className="buttons_jobFunction width-100" >
                                {dataJobFunction.map((item,i)=>(
                                    <button key={i} className="job_item"  onClick={(e)=>{this.changeJob(item.id)}}  value={item.id}
                                    style={{
                                        color: (this.selectField(job_function_id, item.id) ? "#3B6C98":"" || job_function_id.length>=5 && this.disabledField(job_function_id, item.id)? "#BDBDBD":"" ),
                                        borderColor: (this.selectField(job_function_id, item.id) ? "#3B6C98":"" || job_function_id.length>=5 && this.disabledField(job_function_id, item.id)? "white":"" ),
                                        backgroundColor: (this.selectField(job_function_id, item.id) ? "#ECF1F5":"" || job_function_id.length>=5 && this.selectField(job_function_id, item.id)? "white":"" )}}>
                                        {/* <img effect="blur" loading="lazy" alt="" src={`${API}/File/Job_Function/${item.icon}`}  style={{opacity: this.state.job_function_id.length>=5 &&((this.state.job_function_id[0]  !== item.id )&&(this.state.job_function_id[1]  !== item.id ) &&(this.state.job_function_id[2]  !== item.id )&&(this.state.job_function_id[3]  !== item.id )&&(this.state.job_function_id[4]  !== item.id ))? "0.4":"", filter: (((this.state.job_function_id[0]  === item.id )||(this.state.job_function_id[1]  === item.id ) ||(this.state.job_function_id[2]  === item.id )||(this.state.job_function_id[3]  === item.id )||(this.state.job_function_id[4]  === item.id ))? "invert(37%) sepia(91%) saturate(318%) hue-rotate(167deg) brightness(87%) contrast(90%)":"")}} /> */}
                                        <p>{item.job_function_name} </p>
                                    </button>
                                ))}
                                </div>
                            </div>
                            <p className='c-red s-12'>{data_job["job_function_id_err"]} </p>
                        </div>
                        <div className='list-item width-100 hg-6 bg-ea'/>
                        <div className='p-24' id='industry_id_err'>
                            <p className='w-bold s-16 c-29 mb-24 flex'>Which Industries are you interested in?</p>
                            <div className='flex width-100 wrap jobFunction'>
                                <div className="buttons_jobFunction width-100" >
                                {dataIndustri.map((item,i)=>(
                                    <button key={i} className="job_item"  onClick={(e)=>{this.changeIndustry(item.id)}}  value={item.id} 
                                    style={{
                                        color: (this.selectField(industry_id,item.id)? "#3B6C98":"" || industry_id.length>=5 && this.disabledField(industry_id,item.id)? "#BDBDBD":"" ),
                                         borderColor: ( this.selectField(industry_id, item.id)? "#3B6C98":"" || industry_id.length>=5 && this.selectField(industry_id,item.id)? "white":"" ),
                                         backgroundColor: ( this.selectField(industry_id,item.id)? "#ECF1F5":"" || this.state.industry_id.length>=5 && this.disabledField(industry_id, item.id)? "white":"" )}}>
                                       <p>{item.industry_name} </p>
                                    </button>
                                ))}
                                </div>
                            </div>
                            <p className='c-red s-12'>{data_job["industry_id_err"]} </p>
                        </div>
                        <div className='list-item width-100 hg-6 bg-ea'/>
                        <div className='flex column p-24' id="sure">
                            <div className='bd-187 bg-82 br-5 p-1014 mb-24'>
                                <p className='OpenSans c-29 w-400 s-14'>Make sure all of the information is correct before you apply</p>
                            </div>
                            <button className='m-auto bg-36 br-18 p-1024 bd-36' onClick={(e)=>{this.continue(item.job_opportunity_id)}}>
                                <p className='s-14 w-bold c-ff'>Continue</p>
                            </button>
                        </div>
                        </div>
                        <div className={`column p-24 ${check===2?"flex":"none"}`}>
                            <div className='flex space-between width-100 mb-24'>
                                <div className='flex br-16 bd-ea p-818 pointer' onClick={()=>{this.setState({check:1})}}>
                                    <p className='c-29 w-400 s-14'>Back</p>
                                </div>
                                <p className='w-bold s-24 '>Sign Up</p>
                                <div className='flex br-16 wd-74'>
                                    <p className='c-29 w-400 s-14'> </p>
                                </div>
                            </div>
                            <div className='flex column mb-48'>
                            <div className='flex-mob width-100 space-between'>
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Full Name</p>
                                        <input type='text' value={data_job["full_name"]} onChange={(e)=>(this.setData(e.target.value,"full_name"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{data_job["full_name_err"]} </p>
                                    </div>
                                </div>
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Email</p>
                                        <input type='text' value={data_job["email"]} onChange={(e)=>(this.setData(e.target.value,"email"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <p className='c-red s-12'>{data_job["email_err"]} </p>
                                    </div>
                                </div>
                            </div>
                            <div className='flex-mob width-100 space-between'>
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>New Password</p>
                                        <input type={new_pass? "password":"text"} value={data_job["password"]} onChange={(e)=>(this.setData(e.target.value,"password"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <div className='svg pass' onClick={()=>this.showPass(!new_pass,"new_pass")}>{new_pass? show:hide}</div>
                                    </div>
                                </div>
                                <div className='wd-264 flex column'>
                                    <div className='flex column width-100 mb-14'>
                                        <p className='mb-10 c-29 w-400 OpenSans'>Confirm New Password</p>
                                        <input type={confirm_pass? "password":"text"} value={data_job["confirm_password"]} onChange={(e)=>(this.setData(e.target.value,"confirm_password"))} className=' s-16 OpenSans p-1114 flex out-none bd-ea br-5 shd_' />
                                        <div className='svg pass' onClick={()=>this.showPass(!confirm_pass,"confirm_pass")}>{confirm_pass? show:hide}</div>
                                    </div>
                                </div>
                            </div>
                            <p className='c-red s-12'>{data_job["password_err"]} </p>
                            <div className='flex wrap width-100'>
                                <p className='DM-Sans w-400 s-16 mb5 c-29'>By clicking Sign Up, you agree with Karya Talents'</p>
                                {/* <div className='flex width-100'> */}
                                    <p className='DM-Sans-Medium w-500 s-16 mb5 c-36 text-un36 pointer' onClick={(e)=>this.setState({policy:true})}>Privacy Policy</p>
                                    <p className='DM-Sans w-400 s-16 mb5 c-29 '>&nbsp; and &nbsp;</p>
                                    <p className='DM-Sans-Medium w-500 s-16 mb5 c-36 text-un36 pointer' onClick={(e)=>this.setState({terms:true})}>Terms of Service</p>
                                {/* </div> */}
                            </div>
                            </div>
                            <div className='flex width-100'>
                                <div className='bg-36 bd-36 br-18 p-1024 m-auto pointer' onClick={(e)=>this.signUp()} 
                                // onClick={()=>{this.setState({check:3})}}
                                >
                                    <p className='c-ff s-14 w-bold ' >Sign Up</p>
                                </div>
                            </div>
                        </div>
                        <div className={`column width-100 center ${check===3?"flex":"none"}`}>
                            <div className='flex wd-407 column center mt-48'>
                                <div className='p-24  br-100 bg-36 bd-36 mb-24'>
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_20864_30258)">
                                    <path d="M32.7487 4.89937C30.7761 3.32766 27.4629 0 24 0C20.5627 0 17.3019 3.25959 15.2522 4.89937C12.0098 7.47328 4.98422 13.1398 1.64934 15.8695C1.13374 16.2916 0.718319 16.8229 0.433085 17.425C0.147851 18.0272 -7.31305e-05 18.6852 2.71225e-08 19.3515V43.5C2.71225e-08 45.9853 2.01469 48 4.5 48H43.5C45.9853 48 48 45.9853 48 43.5V19.3512C48.0001 18.6848 47.8521 18.0268 47.5668 17.4245C47.2815 16.8223 46.866 16.291 46.3503 15.869C43.0155 13.1397 35.9912 7.47328 32.7487 4.89937ZM43.5 45H4.5C3.67153 45 3 44.3285 3 43.5V19.3276C3 18.877 3.20203 18.4508 3.55106 18.1658C6.015 16.1545 14.9679 8.95556 17.1178 7.24875C18.7698 5.93156 21.7797 3 24 3C26.2206 3 29.2302 5.93156 30.8822 7.24875C33.0321 8.95566 41.9856 16.1558 44.4491 18.1676C44.6213 18.3083 44.7601 18.4855 44.8554 18.6864C44.9507 18.8873 45.0001 19.1068 45 19.3292V43.5C45 44.3285 44.3285 45 43.5 45ZM42.6794 24.7207C43.0721 25.2041 42.9975 25.9144 42.5129 26.3056C40.3729 28.033 37.344 30.4527 32.7483 34.1007C30.7753 35.6757 27.4166 39.0243 23.9997 38.9999C20.5703 39.0247 17.1723 35.6335 15.2512 34.1003C10.656 30.4526 7.62731 28.0331 5.48719 26.3056C5.00259 25.9144 4.92788 25.2041 5.32069 24.7207L5.79384 24.1384C6.18469 23.6573 6.89109 23.5829 7.37334 23.9722C9.50738 25.695 12.5309 28.1107 17.1175 31.7514C18.6972 33.0112 21.8239 36.0349 24 35.9997C26.1768 36.0345 29.3027 33.0112 30.8825 31.7514C35.4696 28.1103 38.4929 25.6947 40.6267 23.9722C41.109 23.5829 41.8153 23.6573 42.2062 24.1384L42.6794 24.7207Z" fill="white"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_20864_30258">
                                    <rect width="48" height="48" fill="white"/>
                                    </clipPath>
                                    </defs>
                                    </svg>
                                </div>
                                <p className='w-bold s-24 mb-14 c-29'>One more step!</p>
                                <p className='s-1626 c-29 w-400 OpenSans mb-48'>Please check your email to verify your Karya Talents account, and finish the job application process</p>
                                <div className='bg-36 bd-36 br-18 p-1024 mb-100 pointer' onClick={(e)=>this.closeAll(e)}>
                                    <p className='c-ff s-14 w-bold '>Okay</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                ))}
                {/* <Popup_Login parentCallback = {this.handleCallback} ownProps={this.state.link}  /> */}
                <Modal id="failed" visible={this.state.failed} effect="fadeInUp">
                    <div  className="modal_apply">
                        <div className="width-100 flex center">
                        <img loading="lazy" alt="" src={warning_referral} style={{marginTop:"24px", marginBottom:"24px"}}/>
                        </div>
                        <h5>Oops!</h5>
                        <p>Email is already registered Please register with a new email!</p>
                        <div className="width-100 flex center" style={{marginBottom:"20px"}}>
                            <button onClick={(e)=>this.setState({failed:false})}>
                                <p style={{margin:"12px", color:"#4F4F4F"}}>Close</p>
                            </button>
                        </div>
                    </div>
                </Modal>
                <Modal id="terms"
                    visible={this.state.terms}
                    effect="fadeInUp" >
                    <div className="flex column popup-TnC" id="pop-TnC" >
                    <div id="modal-header" className="modal-header-sign">
                        <a href="javascript:void(0);" onClick={() => this.setState({terms:false})}>
                        <LazyLoadImage effect="blur" loading="lazy" alt="" src={closemodal} />
                        </a>
                    </div>
                    <Terms  />
                    </div>
                    </Modal>
                    <Modal
                    id="term"
                    visible={this.state.policy}
                    effect="fadeInUp"
                    >
                    <div className="flex column popup-TnC"  id="pop-TnC" >
                    <div id="modal-header" className="modal-header-sign">
                        <a href="javascript:void(0);" onClick={() => this.setState({policy:false})}>
                        <LazyLoadImage effect="blur" loading="lazy" alt="" src={closemodal} />
                        </a>
                    </div>
                    <Policy />
                    </div>
                    </Modal>
            </React.Fragment>
        );
    }
}

 
const mapStateToProps = (state, ownProps) => {
    return {
      country1: state.countryRed,
      industri1 : state.industriRed,
      jobLevel1 : state.jobLevelRed,
      jobFunction1 : state.jobFunctionRed,
      jobType1 : state.jobTypeRed,
      province1 : state.provinceRed,
      city1 : state.cityRed,
      list1: state.listEducationRed,
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      getCountry: (country_id) =>{
          dispatch(getCountry(country_id))
      },
      getIndustri: () =>{
        dispatch(getIndustri())
      },
      getProvince: (country_id) =>{
        dispatch(getProvince(country_id))
      },
      getCity: (province_id) =>{
        dispatch(getCity(province_id))
      },
      getJobType: () =>{
        dispatch(getJobType())
      },
      getJobFunction: () =>{
        dispatch(getJobFunction())
      },
      getJobLevel: () =>{
        dispatch(getJobLevel())
      },
      getListEducation: () => {
        dispatch(getListEducation());
      },
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(Job_Apply);